/**
 * program
 * Program APIs
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { CapacitorHttp } from '@capacitor/core';
import { HttpParameterCodec, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import Session from 'supertokens-web-js/recipe/session';
import { AuthStrategy } from '@libs/services/auth-strategy';

// @ts-ignore
import { ForceCompleteAggregateDto } from '../model/forceCompleteAggregateDto';
// @ts-ignore
import { ProgramWaitingRoomLinkDto } from '../model/programWaitingRoomLinkDto';
// @ts-ignore
import { RecoverAggregateDataDto } from '../model/recoverAggregateDataDto';
// @ts-ignore
import { RecoverAggregateDataRequestDto } from '../model/recoverAggregateDataRequestDto';
// @ts-ignore
import { RecoverIntakeDataDto } from '../model/recoverIntakeDataDto';
// @ts-ignore
import { RecoverIntakeDataRequestDto } from '../model/recoverIntakeDataRequestDto';
// @ts-ignore
import { StartJobDto } from '../model/startJobDto';
// @ts-ignore
import { StartMissingApptScanJobDto } from '../model/startMissingApptScanJobDto';
// @ts-ignore
import { UpdateWeightLossProgramDto } from '../model/updateWeightLossProgramDto';
// @ts-ignore
import { WeightLossCancelSubDto } from '../model/weightLossCancelSubDto';
// @ts-ignore
import { WeightLossProgramDetailsDto } from '../model/weightLossProgramDetailsDto';
// @ts-ignore
import { WeightLossProgramDto } from '../model/weightLossProgramDto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

@Injectable({
  providedIn: 'root'
})
export class WeightLossProgramAdminService {
  protected basePath = 'http://localhost';
  public defaultHeaders: any = {};
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    @Optional()@Inject(BASE_PATH) basePath: string|string[],
    @Optional() configuration: Configuration,
    @Optional() private readonly authStrategy: AuthStrategy, // Inject the strategy if provided
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      if (Array.isArray(basePath) && basePath.length > 0) {
        basePath = basePath[0];
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }


  /**
   * Cancels subscription and ends Weight Loss program.
   * @param xTENANTID 
   * @param id The program identifier
   */
  public async programWeightLossAdminControllerCancelSubscription(xTENANTID: string, id: string, ): Promise<WeightLossCancelSubDto> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling programWeightLossAdminControllerCancelSubscription.');
    }
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling programWeightLossAdminControllerCancelSubscription.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/program/programs/weight-loss/admin/cancel-subscription/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Creates a new waiting room for program intake in case patient has missed previous intake and returns back the link. The link leads to the new video visit.
   * @param xTENANTID 
   * @param id The program identifier
   */
  public async programWeightLossAdminControllerCreateNewWaitingRoomForExistingIntake(xTENANTID: string, id: string, ): Promise<ProgramWaitingRoomLinkDto> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling programWeightLossAdminControllerCreateNewWaitingRoomForExistingIntake.');
    }
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling programWeightLossAdminControllerCreateNewWaitingRoomForExistingIntake.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const response = await CapacitorHttp.get({
      url: `${this.configuration.basePath}/api/program/programs/weight-loss/admin/waiting-room-link/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Attempts to force complete an aggregate. This endpoint is designed to be used in case that medication order is organized outside of this system.
   * @param xTENANTID 
   * @param id The program identifier
   * @param forceCompleteAggregateDto 
   */
  public async programWeightLossAdminControllerForceCompleteAggregate(xTENANTID: string, id: string, forceCompleteAggregateDto: ForceCompleteAggregateDto, ): Promise<any> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling programWeightLossAdminControllerForceCompleteAggregate.');
    }
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling programWeightLossAdminControllerForceCompleteAggregate.');
    }
    if (forceCompleteAggregateDto === null || forceCompleteAggregateDto === undefined) {
      throw new Error('Required parameter forceCompleteAggregateDto was null or undefined when calling programWeightLossAdminControllerForceCompleteAggregate.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/program/programs/weight-loss/admin/force-complete-aggregate/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`,
        data: forceCompleteAggregateDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Retrieves the weight loss program with all associated data.
   * @param xTENANTID 
   * @param id The program identifier.
   */
  public async programWeightLossAdminControllerGetProgram(xTENANTID: string, id: string, ): Promise<WeightLossProgramDetailsDto> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling programWeightLossAdminControllerGetProgram.');
    }
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling programWeightLossAdminControllerGetProgram.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const response = await CapacitorHttp.get({
      url: `${this.configuration.basePath}/api/program/programs/weight-loss/admin/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Scans active programs for a missing aggregate and tries to fix it
   * @param xTENANTID 
   * @param recoverAggregateDataRequestDto 
   */
  public async programWeightLossAdminControllerRecoverProgramAggregateData(xTENANTID: string, recoverAggregateDataRequestDto: RecoverAggregateDataRequestDto, ): Promise<RecoverAggregateDataDto> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling programWeightLossAdminControllerRecoverProgramAggregateData.');
    }
    if (recoverAggregateDataRequestDto === null || recoverAggregateDataRequestDto === undefined) {
      throw new Error('Required parameter recoverAggregateDataRequestDto was null or undefined when calling programWeightLossAdminControllerRecoverProgramAggregateData.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/program/programs/weight-loss/admin/recover-missing-aggregates`,
        data: recoverAggregateDataRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Scans active programs for a missing intake data and tries to recover it from eligibility flow data.
   * @param xTENANTID 
   * @param recoverIntakeDataRequestDto 
   */
  public async programWeightLossAdminControllerRecoverProgramIntakeData(xTENANTID: string, recoverIntakeDataRequestDto: RecoverIntakeDataRequestDto, ): Promise<RecoverIntakeDataDto> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling programWeightLossAdminControllerRecoverProgramIntakeData.');
    }
    if (recoverIntakeDataRequestDto === null || recoverIntakeDataRequestDto === undefined) {
      throw new Error('Required parameter recoverIntakeDataRequestDto was null or undefined when calling programWeightLossAdminControllerRecoverProgramIntakeData.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/program/programs/weight-loss/admin/recover-intake-data`,
        data: recoverIntakeDataRequestDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Scans programs for missing appointments and tries to resend them.
   * @param xTENANTID 
   * @param startMissingApptScanJobDto 
   */
  public async programWeightLossAdminControllerScanProgramsForMissingAppointmentsAndResend(xTENANTID: string, startMissingApptScanJobDto: StartMissingApptScanJobDto, ): Promise<any> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling programWeightLossAdminControllerScanProgramsForMissingAppointmentsAndResend.');
    }
    if (startMissingApptScanJobDto === null || startMissingApptScanJobDto === undefined) {
      throw new Error('Required parameter startMissingApptScanJobDto was null or undefined when calling programWeightLossAdminControllerScanProgramsForMissingAppointmentsAndResend.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/program/programs/weight-loss/admin/start-missing-appt-scan-job`,
        data: startMissingApptScanJobDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Starts the job that scans programs and creates check-ins if needed.
   * The job consists out of: creating check-ins for program instances that need it, schedules check-in notifications. NOTE: This will trigger job for all programs in a system
   * @param xTENANTID 
   * @param startJobDto 
   */
  public async programWeightLossAdminControllerStartCheckInJob(xTENANTID: string, startJobDto: StartJobDto, ): Promise<any> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling programWeightLossAdminControllerStartCheckInJob.');
    }
    if (startJobDto === null || startJobDto === undefined) {
      throw new Error('Required parameter startJobDto was null or undefined when calling programWeightLossAdminControllerStartCheckInJob.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/program/programs/weight-loss/admin/start-check-in-job`,
        data: startJobDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Starts the job that scans programs and checks conditions.
   * The job consists out of: processing programs and checking conditions. NOTE: This will trigger job for all programs in a system
   * @param xTENANTID 
   * @param startJobDto 
   */
  public async programWeightLossAdminControllerStartConditionCheckJob(xTENANTID: string, startJobDto: StartJobDto, ): Promise<any> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling programWeightLossAdminControllerStartConditionCheckJob.');
    }
    if (startJobDto === null || startJobDto === undefined) {
      throw new Error('Required parameter startJobDto was null or undefined when calling programWeightLossAdminControllerStartConditionCheckJob.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/program/programs/weight-loss/admin/start-condition-check-job`,
        data: startJobDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Starts the job that scans programs and creates empower orders.
   * The job consists out of: processing program aggregates and sending empower orders. NOTE: This will trigger job for all programs in a system
   * @param xTENANTID 
   */
  public async programWeightLossAdminControllerStartOrderingJob(xTENANTID: string, ): Promise<any> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling programWeightLossAdminControllerStartOrderingJob.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/program/programs/weight-loss/admin/start-ordering-job`,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Starts the job that scans programs and processes payments.
   * The job consists out of: processing payments and sending notification. NOTE: This will trigger job for all programs in a system
   * @param xTENANTID 
   * @param startJobDto 
   */
  public async programWeightLossAdminControllerStartPaymentJob(xTENANTID: string, startJobDto: StartJobDto, ): Promise<any> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling programWeightLossAdminControllerStartPaymentJob.');
    }
    if (startJobDto === null || startJobDto === undefined) {
      throw new Error('Required parameter startJobDto was null or undefined when calling programWeightLossAdminControllerStartPaymentJob.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/program/programs/weight-loss/admin/start-payment-job`,
        data: startJobDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Processes single program and creates check-ins/notifications if needed.
   * @param xTENANTID 
   * @param id 
   * @param startJobDto 
   */
  public async programWeightLossAdminControllerTriggerCheckInForProgram(xTENANTID: string, id: string, startJobDto: StartJobDto, ): Promise<any> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling programWeightLossAdminControllerTriggerCheckInForProgram.');
    }
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling programWeightLossAdminControllerTriggerCheckInForProgram.');
    }
    if (startJobDto === null || startJobDto === undefined) {
      throw new Error('Required parameter startJobDto was null or undefined when calling programWeightLossAdminControllerTriggerCheckInForProgram.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/program/programs/weight-loss/admin/check-in/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`,
        data: startJobDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Processes single program and creates payments/notifications if needed with error.
   * @param xTENANTID 
   * @param id 
   * @param startJobDto 
   */
  public async programWeightLossAdminControllerTriggerErrorPaymentForProgram(xTENANTID: string, id: string, startJobDto: StartJobDto, ): Promise<any> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling programWeightLossAdminControllerTriggerErrorPaymentForProgram.');
    }
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling programWeightLossAdminControllerTriggerErrorPaymentForProgram.');
    }
    if (startJobDto === null || startJobDto === undefined) {
      throw new Error('Required parameter startJobDto was null or undefined when calling programWeightLossAdminControllerTriggerErrorPaymentForProgram.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/program/programs/weight-loss/admin/pay-error/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`,
        data: startJobDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Processes single program and creates orders/notifications if needed.
   * @param xTENANTID 
   * @param id 
   */
  public async programWeightLossAdminControllerTriggerOrderForProgram(xTENANTID: string, id: string, ): Promise<any> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling programWeightLossAdminControllerTriggerOrderForProgram.');
    }
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling programWeightLossAdminControllerTriggerOrderForProgram.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/program/programs/weight-loss/admin/order/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * @param xTENANTID 
   * @param id 
   */
  public async programWeightLossAdminControllerTriggerPaymentErrorForProgram(xTENANTID: string, id: string, ): Promise<any> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling programWeightLossAdminControllerTriggerPaymentErrorForProgram.');
    }
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling programWeightLossAdminControllerTriggerPaymentErrorForProgram.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/program/programs/weight-loss/admin/notification/pay-error/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Processes single program and creates payments/notifications if needed.
   * @param xTENANTID 
   * @param id 
   * @param startJobDto 
   */
  public async programWeightLossAdminControllerTriggerPaymentForProgram(xTENANTID: string, id: string, startJobDto: StartJobDto, ): Promise<any> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling programWeightLossAdminControllerTriggerPaymentForProgram.');
    }
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling programWeightLossAdminControllerTriggerPaymentForProgram.');
    }
    if (startJobDto === null || startJobDto === undefined) {
      throw new Error('Required parameter startJobDto was null or undefined when calling programWeightLossAdminControllerTriggerPaymentForProgram.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/program/programs/weight-loss/admin/pay/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`,
        data: startJobDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * @param xTENANTID 
   * @param id 
   */
  public async programWeightLossAdminControllerTriggerPaymentSuccessForProgram(xTENANTID: string, id: string, ): Promise<any> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling programWeightLossAdminControllerTriggerPaymentSuccessForProgram.');
    }
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling programWeightLossAdminControllerTriggerPaymentSuccessForProgram.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/program/programs/weight-loss/admin/notification/pay-success/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * Processes single program and checks price changes.
   * @param xTENANTID 
   * @param id 
   * @param startJobDto 
   */
  public async programWeightLossAdminControllerTriggerPriceCheckForProgram(xTENANTID: string, id: string, startJobDto: StartJobDto, ): Promise<any> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling programWeightLossAdminControllerTriggerPriceCheckForProgram.');
    }
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling programWeightLossAdminControllerTriggerPriceCheckForProgram.');
    }
    if (startJobDto === null || startJobDto === undefined) {
      throw new Error('Required parameter startJobDto was null or undefined when calling programWeightLossAdminControllerTriggerPriceCheckForProgram.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/program/programs/weight-loss/admin/price-check/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`,
        data: startJobDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * @param xTENANTID 
   * @param id 
   * @param updateWeightLossProgramDto 
   */
  public async programWeightLossAdminControllerUpdateProgram(xTENANTID: string, id: string, updateWeightLossProgramDto: UpdateWeightLossProgramDto, ): Promise<WeightLossProgramDto> {
    if (xTENANTID === null || xTENANTID === undefined) {
      throw new Error('Required parameter xTENANTID was null or undefined when calling programWeightLossAdminControllerUpdateProgram.');
    }
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling programWeightLossAdminControllerUpdateProgram.');
    }
    if (updateWeightLossProgramDto === null || updateWeightLossProgramDto === undefined) {
      throw new Error('Required parameter updateWeightLossProgramDto was null or undefined when calling programWeightLossAdminControllerUpdateProgram.');
    }

    const localVarHeaders = this.defaultHeaders;
    if (xTENANTID) {
      localVarHeaders['X-TENANT-ID'] = String(xTENANTID);
    }

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const response = await CapacitorHttp.patch({
      url: `${this.configuration.basePath}/api/program/programs/weight-loss/admin/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`,
        data: updateWeightLossProgramDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
}
